// extracted by mini-css-extract-plugin
module.exports = {"container":"DepositMethodIcons_container__YIoQJ"};